import { GanttStatic } from "dhtmlx-gantt";

const hourRangeFormat = (step, gantt) => {
  return (date) => {
    const hourToStr = gantt.date.date_to_str("%H:%i");
    const intervalEnd = new Date(gantt.date.add(date, step, "hour") - 1);
    return hourToStr(date) + " - " + hourToStr(intervalEnd);
  };
};
const minuteRangeFormat = (step, gantt) => {
	return (date) => {
	  const hourToStr = gantt.date.date_to_str("%i");
	  const intervalEnd = new Date(gantt.date.add(date, step, "minute") - 1);
	  return hourToStr(date) + " - " + hourToStr(intervalEnd);
	};
  };
export const zoomConfigOld = (gantt) => {
  return {
    minColumnWidth: 80,
    maxColumnWidth: 150,
    levels: [
      [
        { unit: "month", format: "%M %Y", step: 1 },
        {
          unit: "week",
          step: 1,
          format: (date) => {
            const dateToStr = gantt.date.date_to_str("%d %M");
            const endDate = gantt.date.add(date, -6, "day");
            const weekNum = gantt.date.date_to_str("%W")(date);
            return (
              $localize`Week #` +
              weekNum +
              ", " +
              dateToStr(date) +
              " - " +
              dateToStr(endDate)
            );
          },
        },
      ],
      [
        { unit: "month", format: "%M %Y", step: 1 },
        { unit: "day", format: "%d %M", step: 1 },
      ],
      [
        { unit: "day", format: "%d %M", step: 1 },
        { unit: "hour", format: hourRangeFormat(12, gantt), step: 12 },
      ],
      [
        { unit: "day", format: "%d %M", step: 1 },
        { unit: "hour", format: hourRangeFormat(6, gantt), step: 6 },
      ],
      [
        { unit: "day", format: "%d %M", step: 1 },
        { unit: "hour", format: "%H:%i", step: 1 },
      ],
    ],
    useKey: "ctrlKey",
    trigger: "wheel",
    element: () => {
      return gantt.$root.querySelector(".gantt_task");
    },
  };
};
export const zoomConfig: any = (gantt: GanttStatic) => {
  return {
    levels: [
      // minutes
      {
        name: "minute",
        scale_height: 50,
        scales: [
          { unit: "day", step: 1, format: "%d %M" },
          { unit: "hour", step: 1, format: "%H:%i" },
          { unit: "minute", step: 1, format: "%H:%i" },
        ],
      },
      // half_hour
      {
        name: "half_hour",
        scale_height: 50,
        scales: [
          { unit: "day", step: 1, format: "%d %M" },
          { unit: "hour", step: 1, format: "%H:%i" },
          { unit: "minute", format: minuteRangeFormat(30, gantt), step: 30,width: 50 },
        ],
      },
      // hours
      {
        name: "hour",
        scale_height: 27,
        scales: [
          { unit: "day", step: 1, format: "%d %M" },
          { unit: "hour", step: 1, format: "%H:%i" },
        ],
      },
	   // half_day
	   {
        name: "half_day",
        scale_height: 27,
        scales: [
          { unit: "day", step: 1, format: "%d %M" },
          { unit: "hour", step: 12, format: "%H:%i" },
        ],
      },
      // days
      {
        name: "day",
        scale_height: 27,
        scales: [{ unit: "day", step: 1, format: "%d %M" }],
      },
      // weeks
      {
        name: "week",
        scale_height: 50,
        scales: [
          {
            unit: "week",
            step: 1,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%d %M");
              var endDate = gantt.date.add(date, +6, "day");
              var weekNum = gantt.date.date_to_str("%W")(date);
              return (
                $localize`Week #` +
                weekNum +
                ", " +
                dateToStr(date) +
                " - " +
                dateToStr(endDate)
              );
            },
          },
          { unit: "day", step: 1, format: "%j %D" },
        ],
      },
      // months
      {
        name: "month",
        scale_height: 50,
        scales: [
          { unit: "month", step: 1, format: "%F, %Y" },
          {
            unit: "week",
            step: 1,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%d %M");
              var endDate = gantt.date.add(
                gantt.date.add(date, 1, "week"),
                -1,
                "day"
              );
              return dateToStr(date) + " - " + dateToStr(endDate);
            },
          },
        ],
      },
      // quarters
      {
        name: "quarter",
        height: 50,
        scales: [
          {
            unit: "quarter",
            step: 3,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%M %y");
              var endDate = gantt.date.add(
                gantt.date.add(date, 3, "month"),
                -1,
                "day"
              );
              return dateToStr(date) + " - " + dateToStr(endDate);
            },
          },
          { unit: "month", step: 1, format: "%M" },
        ],
      },
      // years
      {
        name: "year",
        scale_height: 50,
        scales: [
          {
            unit: "year",
            step: 5,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%Y");
              var endDate = gantt.date.add(
                gantt.date.add(date, 5, "year"),
                -1,
                "day"
              );
              return dateToStr(date) + " - " + dateToStr(endDate);
            },
          },
        ],
      },
      // decades
      {
        name: "year",
        scale_height: 50,
        scales: [
          {
            unit: "year",
            step: 100,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%Y");
              var endDate = gantt.date.add(
                gantt.date.add(date, 100, "year"),
                -1,
                "day"
              );
              return dateToStr(date) + " - " + dateToStr(endDate);
            },
          },
          {
            unit: "year",
            step: 10,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str("%Y");
              var endDate = gantt.date.add(
                gantt.date.add(date, 10, "year"),
                -1,
                "day"
              );
              return dateToStr(date) + " - " + dateToStr(endDate);
            },
          },
        ],
      },
    ],
    // useKey: "ctrlKey",
    // trigger: "wheel",
    element: function () {
      return (gantt as any).$root.querySelector(".gantt_task");
    },
  };
};
